(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("harbinger", [], factory);
	else if(typeof exports === 'object')
		exports["harbinger"] = factory();
	else
		root["harbinger"] = factory();
})(this, function() {
return 